import * as React from 'react';
import {useForm, Controller, SubmitHandler} from 'react-hook-form';
import {Select} from './BlogFormInputs';
//const BlogPostSelectSeasonV2 = React.forwardRef<>({
//  handleSeasonChange,
//  selectedSeason,
//},ref: BlogPostSelectSeasonPropsTypeV2) => {

interface IFormInputs {
  Season: string;
  NewSeason: string;
  RoundName: string;
}

//<select {...register(name)} {...rest}></select>
// const Select = ({register, name, options, defaultValue, ...rest}: any) => {
//   return (
//     <select defaultValue={defaultValue} {...register(name)} {...rest}>
//       {options.map((option: string, index: string) => (
//         <option value={option} key={index}>
//           {option}
//         </option>
//       ))}
//     </select>
//   );
// };

const BlogPostSelectSeasonV3 = ({register, setValue, selectedSeason}: any) => {
  let today = new Date();
  let year: number = today.getFullYear();
  let yearArray: Array<string> = [];
  for (let i = year + 1, x = 0; i >= year - 10; i--, x++) {
    yearArray[x] = i.toString() + '-' + (i + 1).toString().substring(2, 4);
  }
  let selected: string =
    selectedSeason !== ''
      ? selectedSeason
      : year.toString() + '-' + (year + 1).toString().substring(2, 4);
  React.useEffect(() => {
    setValue('Round', '');
    setValue('Comp', '');
  }, [selectedSeason, setValue]);
  return (
    <Select
      name="Season"
      register={register}
      options={yearArray}
      defaultValue={selected}
    />
  );
};

export default BlogPostSelectSeasonV3;
